export const sportCategories = [
  { slug: 'football', name: '足球', icon: 'ri-football-line', color: 'primary' },
  { slug: 'basketball', name: '篮球', icon: 'ri-basketball-line', color: 'accent' },
  { slug: 'tennis', name: '网球', icon: 'ri-base-station-line', color: 'secondary' },
  { slug: 'esports', name: '电竞', icon: 'ri-gamepad-line', color: 'primary' },
  { slug: 'racing', name: '赛车', icon: 'ri-steering-line', color: 'accent' },
  { slug: 'boxing', name: '搏击', icon: 'ri-boxing-line', color: 'secondary' },
  { slug: 'swimming', name: '游泳', icon: 'ri-water-flash-line', color: 'primary' },
  { slug: 'golf', name: '高尔夫', icon: 'ri-golf-ball-line', color: 'accent' },
];

export const liveEvents = [
  {
    id: 'live-1',
    title: '英超联赛第28轮',
    subtitle: '曼城 vs 利物浦',
    league: '英超',
    status: 'live',
    score: { home: 2, away: 1 },
    time: '72\'',
    viewers: 1283500,
    category: 'football',
  },
  {
    id: 'live-2',
    title: 'NBA常规赛',
    subtitle: '湖人 vs 勇士',
    league: 'NBA',
    status: 'live',
    score: { home: 98, away: 102 },
    time: 'Q4 3:21',
    viewers: 965200,
    category: 'basketball',
  },
  {
    id: 'live-3',
    title: '法网公开赛男单半决赛',
    subtitle: '德约科维奇 vs 阿尔卡拉斯',
    league: '法网',
    status: 'live',
    score: { home: 2, away: 1 },
    time: '第三盘',
    viewers: 756800,
    category: 'tennis',
  },
  {
    id: 'live-4',
    title: 'LPL夏季赛常规赛',
    subtitle: 'JDG vs BLG',
    league: 'LPL',
    status: 'upcoming',
    startTime: '今天 19:00',
    viewers: 523400,
    category: 'esports',
  },
  {
    id: 'live-5',
    title: 'F1摩纳哥大奖赛',
    subtitle: '排位赛',
    league: 'F1',
    status: 'upcoming',
    startTime: '今天 21:00',
    viewers: 412300,
    category: 'racing',
  },
  {
    id: 'live-6',
    title: 'UFC格斗之夜',
    subtitle: '张伟丽 vs 罗斯',
    league: 'UFC',
    status: 'replay',
    startTime: '回放',
    viewers: 689100,
    category: 'boxing',
  },
];

export const newsArticles = [
  {
    id: 1,
    title: '欧冠八强出炉：皇马曼城领衔，意甲三强齐聚创造历史',
    summary: '2025-2026赛季欧冠联赛八强全部产生，皇家马德里与曼城领衔豪华阵容，意甲国际米兰、AC米兰、尤文图斯三支球队同时晋级，创造了意甲在欧冠历史上的新纪录。',
    category: 'football',
    imageSeq: 'news-01',
    date: '2026-08-07',
    author: '体育观察员',
    views: 128500,
    tags: ['欧冠', '皇马', '曼城', '意甲'],
    content: `<p>2025-2026赛季欧洲冠军联赛八分之一决赛全部结束，八强阵容正式出炉。本届欧冠八强堪称近年来最具看点的阵容，皇家马德里、曼城、拜仁慕尼黑、巴黎圣日耳曼、国际米兰、AC米兰、尤文图斯和本菲卡成功晋级。</p>
<p>皇家马德里在八分之一决赛中以总比分4-2淘汰了英超劲旅阿森纳，展现了强大的欧冠基因。曼城则以总比分5-1轻松淘汰埃因霍温，继续朝卫冕目标迈进。</p>
<p>最令人瞩目的是意甲三强——国际米兰、AC米兰和尤文图斯同时晋级八强，这是自2005-06赛季以来意甲球队在欧冠八强中的最佳表现。国际米兰两回合3-2淘汰马德里竞技，AC米兰点球大战险胜多特蒙德，尤文图斯则凭借稳固防守2-0淘汰了葡超豪门波尔图。</p>
<p>拜仁慕尼黑以总比分6-2大胜哥本哈根，巴黎圣日耳曼4-3险胜巴塞罗那，本菲卡则爆冷淘汰了那不勒斯。八强抽签将于本周五进行，球迷们已经开始热议各种可能的对阵组合。</p>`,
  },
  {
    id: 2,
    title: 'NBA季后赛：湖人勇士经典对决再现，詹姆斯库里再续传奇',
    summary: 'NBA季后赛西部半决赛，洛杉矶湖人与金州勇士的系列赛战成2-2平，詹姆斯与库里的巅峰对决让全球球迷大呼过瘾，天王山之战备受期待。',
    category: 'basketball',
    imageSeq: 'news-02',
    date: '2026-08-06',
    author: '篮球评论员',
    views: 98600,
    tags: ['NBA', '湖人', '勇士', '詹姆斯', '库里'],
    content: `<p>NBA季后赛西部半决赛激战正酣，洛杉矶湖人与金州勇士的系列赛已经进行了四场，双方战成2-2平。这个系列赛被媒体和球迷誉为"当代最伟大的季后赛对决之一"。</p>
<p>39岁的勒布朗·詹姆斯在系列赛中场均贡献28.5分、8.3个篮板和7.5次助攻，依然是湖人队的绝对核心。而斯蒂芬·库里则在G4中砍下42分，其中三分球14投9中，带领勇士在客场扳平大比分。</p>
<p>两队的战术博弈也极具看点：湖人依靠内线优势和詹姆斯的组织能力，勇士则以外线投射和快速转换进攻为武器。G5天王山之战将在勇士主场大通中心进行，这场比赛很可能决定整个系列赛的走向。</p>`,
  },
  {
    id: 3,
    title: '中国女排3-0完胜巴西，世界女排联赛豪取六连胜',
    summary: '中国女排在2026世界女排联赛中表现出色，以3-0横扫巴西女排，取得六连胜的骄人战绩，李盈莹独得22分荣膺全场得分王。',
    category: 'football',
    imageSeq: 'news-03',
    date: '2026-08-05',
    author: '排球观察者',
    views: 75600,
    tags: ['女排', '中国女排', '世界联赛', '李盈莹'],
    content: `<p>2026年世界女排联赛第三周比赛继续在澳门进行，中国女排坐镇主场迎战巴西女排。最终中国队以3-0（25-18、25-22、25-20）完胜对手，豪取六连胜。</p>
<p>主攻手李盈莹全场轰下22分，其中扣球18分、拦网3分、发球1分，荣膺全场得分王。队长袁心玥贡献14分，包括4个拦网得分。二传手刁琳宇的调度也非常出色，多次为攻手创造一对一机会。</p>
<p>主教练蔡斌赛后表示："球队的状态越来越好，但接下来还有更强的对手等着我们。巴西队是一支非常有实力的队伍，今天我们的发球和拦网做得很好，这是取胜的关键。"</p>
<p>中国女排将在明天迎战土耳其女排，这将是世界排名前两位球队之间的巅峰对决。</p>`,
  },
  {
    id: 4,
    title: 'F1加拿大站：维斯塔潘杆位夺冠，周冠宇创个人最佳第八名',
    summary: 'F1加拿大大奖赛精彩落幕，红牛车手维斯塔潘从杆位出发全程领跑夺冠。中国车手周冠宇表现出色，以第八名完赛，创造了个人赛季最佳战绩。',
    category: 'racing',
    imageSeq: 'news-04',
    date: '2026-08-04',
    author: 'F1特约记者',
    views: 62300,
    tags: ['F1', '维斯塔潘', '周冠宇', '加拿大站'],
    content: `<p>2026赛季F1世界一级方程式锦标赛第九站——加拿大大奖赛在蒙特利尔吉尔斯·维伦纽夫赛道落下帷幕。红牛车队的马克斯·维斯塔潘从杆位出发，全程领跑，轻松拿下本赛季第七个分站冠军。</p>
<p>法拉利车队的勒克莱尔获得亚军，迈凯伦车队的诺里斯获得季军。比赛中最令人惊喜的是阿尔法·罗密欧车队的中国车手周冠宇，他从第12位起步，凭借出色的轮胎管理和超车技术，最终以第八名的成绩完赛，创造了个人本赛季的最佳战绩。</p>
<p>周冠宇赛后激动地表示："这是团队所有人努力的结果。蒙特利尔是我最喜欢的赛道之一，今天的赛车状态非常好，我能够充分发挥自己的节奏。"下周F1将移师西班牙巴塞罗那，继续欧洲赛程。</p>`,
  },
  {
    id: 5,
    title: '英雄联盟全球总决赛席位确定：四支LPL战队出征韩国',
    summary: '随着LPL夏季赛的结束，代表LPL出征2026英雄联盟全球总决赛的四支战队正式确定：JDG、BLG、TES和WBG将前往韩国争夺召唤师杯。',
    category: 'esports',
    imageSeq: 'news-05',
    date: '2026-08-03',
    author: '电竞频道主编',
    views: 145200,
    tags: ['英雄联盟', 'S赛', 'LPL', 'JDG', 'BLG'],
    content: `<p>随着2026年LPL夏季赛总决赛的结束，代表LPL赛区出征英雄联盟全球总决赛（S16）的四支战队正式确定。一号种子JDG在夏季赛决赛中以3-1击败BLG夺冠，BLG凭借全年积分优势成为二号种子，TES通过冒泡赛首位出线成为三号种子，WBG则在冒泡赛决赛中击败LNG锁定最后一个名额。</p>
<p>2026年全球总决赛将于9月在韩国首尔、釜山两座城市举行，决赛将在首尔世界杯竞技场举办。LPL赛区作为过去两届全球总决赛的冠军赛区，今年将力争实现三连冠的伟业。</p>
<p>JDG中单选手Knight在赛后采访中表示："今年的目标只有一个，就是冠军。我们在MSI上已经击败过LCK队伍，对韩国赛场也不陌生。我相信我们可以把召唤师杯再次带回LPL。"</p>`,
  },
  {
    id: 6,
    title: '世界游泳锦标赛：覃海洋100米蛙泳刷新亚洲纪录夺冠',
    summary: '2026世界游泳锦标赛在多哈继续进行，中国选手覃海洋在男子100米蛙泳决赛中以57.68秒的成绩刷新亚洲纪录并夺得冠军。',
    category: 'swimming',
    imageSeq: 'news-06',
    date: '2026-08-02',
    author: '游泳专线记者',
    views: 54300,
    tags: ['游泳', '覃海洋', '世锦赛', '蛙泳'],
    content: `<p>2026年世界游泳锦标赛在卡塔尔多哈继续进行第四个比赛日的争夺。在男子100米蛙泳决赛中，中国选手覃海洋以57.68秒的惊人成绩刷新亚洲纪录并夺得冠军！</p>
<p>覃海洋在前50米就建立了明显优势，转身后更加势不可挡，最终以0.52秒的优势力压英国名将亚当·皮蒂夺冠。57.68秒的成绩距离世界纪录仅差0.13秒，展现了覃海洋近年来的巨大进步。</p>
<p>"这个成绩是团队和我个人长期努力的结果，"覃海洋在赛后表示，"亚洲纪录只是一个开始，我的目标是打破世界纪录并站上奥运会的最高领奖台。"中国游泳队在本届世锦赛已经收获3金2银1铜。</p>`,
  },
];

export const bettingRecommendations = [
  {
    id: 'bet-1',
    match: '曼城 vs 利物浦',
    league: '英超',
    time: '今天 22:00',
    odds: { home: 1.85, draw: 3.60, away: 4.20 },
    recommendation: '主胜',
    confidence: 78,
    analysis: '曼城主场强势，近10个主场9胜1平',
  },
  {
    id: 'bet-2',
    match: '湖人 vs 勇士',
    league: 'NBA',
    time: '今天 10:30',
    odds: { home: 1.65, spread: -5.5, away: 2.30 },
    recommendation: '湖人让分胜',
    confidence: 72,
    analysis: '湖人内线优势明显，主场作战气势更足',
  },
  {
    id: 'bet-3',
    match: 'JDG vs BLG',
    league: 'LPL',
    time: '今天 17:00',
    odds: { home: 1.55, draw: null, away: 2.45 },
    recommendation: 'JDG胜',
    confidence: 85,
    analysis: 'JDG近期状态火热，中野联动无解',
  },
  {
    id: 'bet-4',
    match: '德约科维奇 vs 阿尔卡拉斯',
    league: '法网',
    time: '今天 20:30',
    odds: { home: 2.10, draw: null, away: 1.75 },
    recommendation: '阿尔卡拉斯胜',
    confidence: 68,
    analysis: '阿尔卡拉斯红土赛季状态惊人',
  },
];

export const healthTips = [
  {
    id: 'tip-1',
    title: '跑步前必做的5个热身动作',
    summary: '科学热身能有效预防运动损伤，提升跑步表现',
    icon: 'ri-run-line',
    readTime: '5分钟',
  },
  {
    id: 'tip-2',
    title: '篮球爱好者如何保护膝盖',
    summary: '掌握正确的落地技巧和力量训练方法',
    icon: 'ri-heart-pulse-line',
    readTime: '8分钟',
  },
  {
    id: 'tip-3',
    title: '运动后恢复的黄金30分钟',
    summary: '运动后的营养补充和拉伸放松至关重要',
    icon: 'ri-timer-line',
    readTime: '4分钟',
  },
  {
    id: 'tip-4',
    title: '游泳健身的十大好处',
    summary: '全身性运动之王：从心肺到肌肉的全方位锻炼',
    icon: 'ri-water-flash-line',
    readTime: '6分钟',
  },
  {
    id: 'tip-5',
    title: '电竞选手的护眼与颈椎保养',
    summary: '长时间面对屏幕的专业养护指南',
    icon: 'ri-eye-line',
    readTime: '7分钟',
  },
  {
    id: 'tip-6',
    title: '高强度训练后的营养餐搭配',
    summary: '蛋白质与碳水的黄金比例，加速肌肉恢复',
    icon: 'ri-restaurant-line',
    readTime: '5分钟',
  },
];

export const memberBenefits = [
  { icon: 'ri-vip-crown-line', title: '赛事直播', desc: '高清无延迟，多路信号随心切换' },
  { icon: 'ri-fire-line', title: '竞猜特权', desc: '专属赔率加成，最高返水1.2%' },
  { icon: 'ri-shield-check-line', title: '资金安全', desc: '银行级加密，提款秒到账' },
  { icon: 'ri-customer-service-2-line', title: '专属客服', desc: '7×24小时VIP一对一服务' },
];

export const statistics = [
  { value: '5000万+', label: '注册用户' },
  { value: '200+', label: '覆盖赛事' },
  { value: '99.9%', label: '服务可用率' },
  { value: '30秒', label: '平均提款速度' },
];